import React, { useEffect, useState } from "react";
import "./Quotationcard.css";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import ModalComponent from "../../../Components/Features/ModalComponent";
import { Images, careSupremeBenefits, productDetails } from "../../../Data/Benifits";
import { Tooltip, LinearProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedProvider,
  updatedQuotationResult,
  updatePremiumPostObject,
  storeQuote,
} from "../../../../Redux/Health/action";
import { useNavigate } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { fetchQuotationDataHelper,processQuoteData } from "../../../utils/quotationHelper";

const BajajQuardCard = ({ collectData }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(false);
  const [productFeatures, setProductFeatures] = useState([]);
  const [premium, setPremium] = useState(null);
  const [image, setImage] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const premiumPostBody = useSelector(
    (state) => state?.healthReducer?.premiumPostObject
  );
  const [postBody, setPostBody] = useState(premiumPostBody);
  useEffect(() => {
     fetchQuotationDataHelper({
          postBody,
          provider: "bajaj", 
          selectedCoverage: premiumPostBody?.selectedCoverage,
          setLoading,
          setQuote,
          dispatch
                 });
  }, [postBody,dispatch, premiumPostBody?.selectedCoverage]);

  useEffect(() => {
    setPostBody(premiumPostBody);
  }, [premiumPostBody]);

  const handleModal = () => {
    setModalOpen(!modalOpen);
  };

  useEffect(() => {
    if (quote) {
      processQuoteData({
        quote,
        setProductFeatures,
        setImage,
        setPremium,
        productDetails,
        Images,
        dispatch,
        storeQuote,
      });
    }
  }, [quote,dispatch]);
  

  const handleNavigate = (quote) => {
    let provider = quote.provider;
    let code = quote.code;
    const updatedPostBody = {
      ...postBody,
      provider: provider,
      abacusId: code,
    };

     dispatch(setSelectedProvider("bajaj"));
     dispatch(updatedQuotationResult(quote));
     dispatch(updatePremiumPostObject(updatedPostBody));
    navigate("/health/proposalform");
   
  };

  const handleCheckboxChange = (name, checked) => {
    const updatedPostBody = { ...postBody, [name]: checked ? "1" : "0" };
    setPostBody(updatedPostBody);
  };

  const handleChange = (e) => {
    collectData(e.target.checked, quote);
  };

  return (
    <>
      <ModalComponent
        open={modalOpen}
        handleClose={handleModal}
        quote={quote}
        features={careSupremeBenefits}
      />
      {loading ? (
        <LinearProgress />
      ) : (
        (quote && quote?.premiumWithGST !=="0.0") && (
          <div className="health_quotation_main_card  mb_25 ">
            <div className="mt-2">
              <input
                className="form-check-input"
                onChange={(e) => handleChange(e)}
                type="checkbox"
                style={{
                  fontSize: "25px",
                  marginLeft: "10px",
                  border: "1px solid",
                }}
              />
            </div>
            <div className="d_flex quotation_upr_div">
              <div className="logo_container">
                <img src={image} alt="CARE HEALTH" className="logo_box" />
              </div>

              <div className="quotation_content">
                <div className="content_box_cs">
                  <div className="plane_name plan_details">
                    <div className="title_pa">{quote?.productName}</div>
                    <div className="suminsured_text">
                      Sum Insured : ₹{quote?.sumInsured}
                    </div>
                    <b>{quote?.term || quote?.tenure} year policy</b>
                  </div>

                  <div className="plan_feature plan_details">
                    <div
                      className="health_check_compare"
                      style={{ marginRight: "30px" }}
                    >
                      <ul className="features_list">
                        {productFeatures?.slice(0, 4)?.map((item, i) => (
                          <li key={i} className="font-12">
                            <Tooltip
                              title={item.benefit}
                              placement="right-start"
                            >
                              <HealthAndSafetyIcon
                                fontSize="small"
                                style={{ marginRight: "5px", color: "#03a9f4" }}
                              />
                              <span className="font-blue">{item.feature}</span>
                            </Tooltip>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="health_check_compare">
                      <ul className="features_list">
                        {productFeatures?.slice(4, 8)?.map((item, i) => (
                          <li key={i} className="font-12">
                            <Tooltip
                              title={item.benefit}
                              placement="right-start"
                            >
                              <HealthAndSafetyIcon
                                fontSize="small"
                                style={{ marginRight: "5px", color: "#03a9f4" }}
                              />
                              <span className="font-blue">{item.feature}</span>
                            </Tooltip>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div  onClick={() => handleNavigate(quote)}  className="text_right hal_buy_btn_btn plan_details buy_btn">
                   
                      <Tooltip title="Buy Plan" placement="bottom">
                        <span>
                          <i className="fa-solid fa-indian-rupee-sign mr_5"></i>
                          ₹ {premium}
                        </span>
                      </Tooltip>
                      <p>*Including GST</p>
                      <small>BUY NOW</small>
                    {/* </a> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="d_flex quotation_bottom_div">
              <button onClick={handleModal} className="features_btn">
                View Features <ChevronRightIcon />
              </button>
            </div>

            {/* addons */}
            <div className="add_addon_div">
              <div className="d_flex addons_flex_container">
                {/* Care OPD */}
                <div className="health_addons_input_box">
                  <label>
                    <input
                      checked={Number(postBody.addonme)}
                      type="checkbox"
                      name="addonme"
                      onChange={(e) =>
                        handleCheckboxChange(e.target.name, e.target.checked)
                      }
                    />
                    <span>Non Medical Expense</span>
                  </label>
                </div>

                <div className="health_addons_input_box">
                  <label>
                    <input
                      checked={Number(postBody.addonroomwaiver)}
                      type="checkbox"
                      name="addonroomwaiver"
                      onChange={(e) =>
                        handleCheckboxChange(e.target.name, e.target.checked)
                      }
                    />
                    <span>Room Waiver</span>
                  </label>
                </div>
                 

                <div className="health_addons_input_box">
                  <label>
                    <input
                      checked={Number(postBody.ambulanceCover)}
                      type="checkbox"
                      name="ambulanceCover"
                      onChange={(e) =>
                        handleCheckboxChange(e.target.name, e.target.checked)
                      }
                    />
                    <span>Air Ambulance Cover</span>
                  </label>
                </div>

                <div className="health_addons_input_box">
                  <label>
                    <input
                      checked={Number(postBody.HealthPrimeRidert)}
                      type="checkbox"
                      name="HealthPrimeRidert"
                      onChange={(e) =>
                        handleCheckboxChange(e.target.name, e.target.checked)
                      }
                    />
                    <span>Health Prime Rider</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        )
      )}
    </>
  );
};

export default BajajQuardCard;
